// =============================================
// BOLD AGENCY THEME — JavaScript
// =============================================

(function () {
  'use strict';

  // ── Custom Cursor ────────────────────────
  const cursor = document.getElementById('cursor');
  const follower = document.getElementById('cursorFollower');
  let mx = 0, my = 0, fx = 0, fy = 0;

  if (cursor && follower && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });

    (function animateFollower() {
      fx += (mx - fx) * 0.12;
      fy += (my - fy) * 0.12;
      follower.style.left = fx + 'px';
      follower.style.top  = fy + 'px';
      requestAnimationFrame(animateFollower);
    })();

    document.querySelectorAll('a, button, .btn, .service-row, .industry-tag, .creative-card, .case-card, .number-cell, .sd-service-header, .review-card, .gallery-card, .value-card, .team-card, .nav-link, .mobile-nav-link, .footer-link').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.style.width = '16px';
        cursor.style.height = '16px';
        follower.style.width = '56px';
        follower.style.height = '56px';
        follower.style.borderColor = 'rgba(201,245,61,0.6)';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.width = '8px';
        cursor.style.height = '8px';
        follower.style.width = '32px';
        follower.style.height = '32px';
        follower.style.borderColor = 'rgba(201,245,61,0.4)';
      });
    });
  }

  // ── Header Scroll Effect ─────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile Menu Toggle ──────────────────
  const menuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Close on link click
    mobileMenu.querySelectorAll('.mobile-nav-link').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        menuToggle.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Scroll Reveal ────────────────────────
  const srElements = document.querySelectorAll('.sr');
  if (srElements.length) {
    const srObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          srObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    srElements.forEach(el => srObserver.observe(el));
  }

  // ── Number Counter Animation ─────────────
  function parseNum(str) {
    return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  }
  function formatNum(val, original) {
    const prefix  = original.match(/^[^0-9]*/)[0];
    const suffix  = original.match(/[^0-9.]*$/)[0];
    const isFloat = original.includes('.');
    const rounded = isFloat ? val.toFixed(1) : Math.floor(val).toLocaleString();
    return prefix + rounded + suffix;
  }
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }
  function animateCount(el) {
    const original = el.getAttribute('data-target');
    const target   = parseNum(original);
    const duration = 1800;
    const start    = performance.now();
    (function tick(now) {
      const p = Math.min((now - start) / duration, 1);
      el.textContent = formatNum(target * easeOutExpo(p), original);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = original;
    })(start);
  }

  const counters = document.querySelectorAll('[data-target]');
  if (counters.length) {
    const cObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && !e.target.dataset.counted) {
          e.target.dataset.counted = '1';
          animateCount(e.target);
          cObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(el => cObs.observe(el));
  }

  // ── Multi-Step Form Logic ────────────────
  function initMultiStepForm(formId, stepSelector, stepActiveClass, stepTrackSelector, stepItemSelector, successId) {
    const form = document.getElementById(formId);
    if (!form) return;

    const steps = form.querySelectorAll(stepSelector);
    const stepTrack = document.querySelector(stepTrackSelector);
    const stepItems = stepTrack ? stepTrack.querySelectorAll(stepItemSelector) : [];
    let currentStep = 1;

    function showStep(n) {
      steps.forEach(s => s.classList.remove(stepActiveClass));
      const target = form.querySelector('[data-' + (stepSelector.includes('apply') ? 'apply-' : 'form-') + 'step="' + n + '"]');
      if (target) target.classList.add(stepActiveClass);

      // Update step track
      stepItems.forEach(si => {
        const num = parseInt(si.getAttribute('data-step'));
        si.classList.remove('active', 'done');
        if (num === n) si.classList.add('active');
        else if (num < n) si.classList.add('done');
      });
      currentStep = n;
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validateStep(stepEl) {
      let valid = true;
      const requiredInputs = stepEl.querySelectorAll('[required]');
      requiredInputs.forEach(input => {
        const group = input.closest('.form-group');
        if (!input.value || input.value.trim() === '') {
          if (group) group.classList.add('error');
          valid = false;
        } else if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          if (group) group.classList.add('error');
          valid = false;
        } else {
          if (group) group.classList.remove('error');
        }
      });
      return valid;
    }

    // Clear error on input
    form.querySelectorAll('input, select, textarea').forEach(input => {
      input.addEventListener('input', () => {
        const group = input.closest('.form-group');
        if (group) group.classList.remove('error');
      });
      input.addEventListener('change', () => {
        const group = input.closest('.form-group');
        if (group) group.classList.remove('error');
      });
    });

    // Next buttons
    form.querySelectorAll('.btn-next').forEach(btn => {
      btn.addEventListener('click', () => {
        const currentStepEl = form.querySelector(stepSelector + '.' + stepActiveClass);
        if (validateStep(currentStepEl)) {
          showStep(parseInt(btn.getAttribute('data-goto')));
        }
      });
    });

    // Prev buttons
    form.querySelectorAll('.btn-prev').forEach(btn => {
      btn.addEventListener('click', () => {
        showStep(parseInt(btn.getAttribute('data-goto')));
      });
    });

    // Submit
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const currentStepEl = form.querySelector(stepSelector + '.' + stepActiveClass);
      if (!validateStep(currentStepEl)) return;

      // Hide all steps and show success
      steps.forEach(s => s.classList.remove(stepActiveClass));
      if (stepTrack) stepTrack.style.display = 'none';
      const success = document.getElementById(successId);
      if (success) success.style.display = 'block';
    });
  }

  // Initialize both forms
  initMultiStepForm(
    'bookCallForm',
    '.form-step',
    'form-step-active',
    '.form-steps-track',
    '.fstep',
    'formSuccess'
  );

  initMultiStepForm(
    'applyForm',
    '.apply-form-step',
    'apply-form-step-active',
    '.apply-steps-track',
    '.apply-step',
    'applySuccess'
  );

})();

